module.exports = __webpack_public_path__ + "img/file-spreadsheet.5cabc03f.svg";